import { render, staticRenderFns } from "./Javan.vue?vue&type=template&id=e5e4faf4"
import script from "./Javan.vue?vue&type=script&lang=js"
export * from "./Javan.vue?vue&type=script&lang=js"
import style0 from "./Javan.vue?vue&type=style&index=0&id=e5e4faf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports